"use client";

import calculateAvailableCast from "@/common/function/calculateAvailableCast";
import { GeneralPropsType } from "@/common/types";
import { Campaign, Package } from "@/types/package";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useGlobalData } from "../GlobalData";
export const PackageContext = createContext<any>(null);
function RealtimeDataProvider({
  children
}: GeneralPropsType) {
  const [packagesData, setPackagesData] = useState<any>(undefined);
  const {
    poolStakeSetting,
    userInfo,
    languageData,
    setUserInfo
  } = useGlobalData();
  const [affiliateData, setAffiliateData] = useState<any>(undefined);
  const [generalAffiliateData, setGeneralAffiliateData] = useState<any>(undefined);
  const [referralData, setReferralData] = useState<any>(undefined);
  const [affiliateViewing, setAffiliateViewing] = useState<any>();
  const [tokensRateState, setTokensRateState] = useState<any>(undefined);
  const updatedPackagesData = useMemo(() => {
    if (!packagesData || !poolStakeSetting.current) return undefined;
    const boostSetting = poolStakeSetting.current?.find((e: any) => e.type == "boost");
    let result = {
      ...packagesData,
      packages: packagesData?.packages?.map((e: Package) => {
        const campaign: Campaign = JSON.parse(e?.campaign);
        const condition_gift = e?.condition_gift ? JSON.parse(e?.condition_gift) : null;
        const coupon = e?.coupon ? JSON.parse(e?.coupon) : null;
        const principalPercent = campaign.lockTimes?.config?.length > 0 ? campaign.lockTimes.config.reduce((pre, current) => {
          if (!current.is_claimed) {
            return pre + current.percent;
          } else {
            return pre;
          }
        }, 0) : 100;
        const principalUnclaimed = principalPercent * Number(e.principal) * Number(e.rate_usd) * 0.01;
        return {
          ...e,
          availableCast: e?.is_calculate_interest ? calculateAvailableCast({
            ...e,
            principal: principalUnclaimed.toString()
          }, {
            ...boostSetting,
            block_time: campaign?.lockTimes?.secondsLock - (coupon?.reduce_lock_time ?? 0) || boostSetting?.block_time,
            token_on_block_time: campaign?.lockTimes?.apr || boostSetting?.token_on_block_time,
            block_time_withdraw_origin: campaign?.lockTimes?.secondsLock - (coupon?.reduce_lock_time ?? 0) || boostSetting?.block_time_withdraw_origin
          }, undefined, undefined, !!e?.itemMissions?.length || !!campaign?.lockTimes?.flexibleInterest?.length ? [...(e?.itemMissions || []), {
            startDate: new Date(+e?.time_deposit * 1000)?.toISOString(),
            endDate: new Date(+e?.time_deposit * 1000 + (+campaign?.lockTimes?.secondsLock - (coupon?.reduce_lock_time ?? 0)) * 1000)?.toISOString(),
            percentBoost: campaign?.lockTimes?.apr,
            isDefault: true
          }, ...(campaign?.lockTimes?.flexibleInterest || [])] : undefined)?.availableCast : 0,
          unpackAt: campaign?.lockTimes ? campaign?.lockTimes?.is_flexible ? new Date(+e?.time_deposit * 1000 + (+(campaign?.lockTimes?.minimum_lock_time ?? 0) - (coupon?.reduce_lock_time ?? 0)) * 1000) : new Date(+e?.time_deposit * 1000 + (+campaign?.lockTimes?.secondsLock - (coupon?.reduce_lock_time ?? 0)) * 1000) : new Date(+e.time_deposit * 1000 + +boostSetting?.block_time_withdraw_origin * 1000),
          amount: principalUnclaimed,
          campaign,
          condition_gift,
          coupon,
          totalInterestClaimed: packagesData?.totalInterestClaimed?.[e.id] || 0
        };
      })
    };
    return result;
  }, [packagesData, poolStakeSetting.current]);
  useEffect(() => {
    if (userInfo && !userInfo?.settings?.locale && languageData) {
      const locales = Object.keys(languageData);
      setUserInfo({
        ...userInfo,
        settings: {
          ...userInfo?.settings,
          locale: locales?.[0]
        }
      });
    }
    if (userInfo && !userInfo?.settings?.currency && tokensRateState) {
      const currencies = Object.keys(tokensRateState)?.filter((e: any) => tokensRateState?.[e]?.isDisplay);
      setUserInfo({
        ...userInfo,
        settings: {
          ...userInfo?.settings,
          currency: currencies?.[0]
        }
      });
    }
  }, [userInfo, languageData, tokensRateState]);
  return <PackageContext.Provider value={{
    packagesData: updatedPackagesData,
    setPackagesData,
    affiliateData,
    setAffiliateData,
    generalAffiliateData,
    setGeneralAffiliateData,
    referralData,
    setReferralData,
    affiliateViewing,
    setAffiliateViewing,
    tokensRateState,
    setTokensRateState
  }} data-sentry-element="unknown" data-sentry-component="RealtimeDataProvider" data-sentry-source-file="index.tsx">
            {children}
        </PackageContext.Provider>;
}
export default RealtimeDataProvider;
export const useRealtimeData = () => {
  const context = useContext(PackageContext);
  return context ?? {};
};